import { defaultZodCatch } from '@/lib/converters/defaultZodCatch'
import { sortDirectionEnumConverter } from '@/lib/converters/sortDirectionEnum/sortDirectionEnumConverter'
import { zPagination } from '@/schemas/paginationSchema'

import type { PaginationDto as ResponseDto } from '@/gen/bff'
import type { PaginationSchema } from '@/schemas/paginationSchema'

export const paginationConverter = (data: ResponseDto): PaginationSchema => {
  const response: PaginationSchema = {
    page: data.page,
    pageSize: data.pageSize,
    totalPages: data.totalPages,
    totalResults: data.totalResults ? Number(data.totalResults) : undefined,
    sortBy: data.sortBy ?? null,
    sortDirection: sortDirectionEnumConverter(data.sortDirection),
  }

  return zPagination.catch(defaultZodCatch).parse(response)
}
